import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'cmp-sila-core',
    templateUrl: './sila-core.component.html',
    styleUrls: ['./sila-core.component.scss']
})
export class SilaCoreComponent implements OnInit {
    ngOnInit() {}
}
